<div class="catalog">
  <app-site-header />

  <div class="catalog__page-head">
    <div class="kota-container catalog__page-head-inner">
      <nav class="breadcrumb" aria-label="Migas de pan">
        <a routerLink="/" class="breadcrumb__link">Inicio</a>
        <span class="breadcrumb__sep" aria-hidden="true">/</span>
        <span class="breadcrumb__current">Catálogo</span>
      </nav>
      <h1 class="catalog__title">Todos los Productos</h1>

      <div class="catalog__toolbar">
        <div class="catalog__filters">
          <button type="button" class="filter-pill" [class.filter-pill--active]="filter() === 'all'" (click)="setFilter('all')">
            Todos
          </button>
          <button
            type="button"
            class="filter-pill"
            [class.filter-pill--active]="filter() === 'recamaras'"
            (click)="setFilter('recamaras')"
          >
            Recámaras
          </button>
          <button
            type="button"
            class="filter-pill"
            [class.filter-pill--active]="filter() === 'muebles'"
            (click)="setFilter('muebles')"
          >
            Muebles
          </button>
        </div>

        <div class="catalog__sort">
          <span class="catalog__sort-label">Ordenar por:</span>
          <div class="sort" [class.sort--open]="sortOpen()">
            <button type="button" class="sort__trigger" (click)="toggleSort()" aria-haspopup="listbox" [attr.aria-expanded]="sortOpen()">
              <span>{{ sortLabel() }}</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path d="m6 9 6 6 6-6" />
              </svg>
            </button>
            @if (sortOpen()) {
              <ul class="sort__menu" role="listbox">
                @for (opt of sortOptions; track opt.value) {
                  <li role="option">
                    <button type="button" class="sort__option" [class.sort__option--active]="sort() === opt.value" (click)="setSort(opt.value)">
                      {{ opt.label }}
                    </button>
                  </li>
                }
              </ul>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="catalog__grid-wrap">
    <div class="kota-container">
      <div class="catalog__grid kota-enter-stagger">
        @for (p of pageItems(); track p.id) {
          <article class="cat-product">
            <a class="cat-product__media" [routerLink]="['/producto', p.slug]">
              <div class="cat-product__img-wrap">
                <img [src]="p.image" [alt]="p.name" width="300" height="248" loading="lazy" />
                @if (p.tag) {
                  <span
                    class="cat-product__tag"
                    [class.cat-product__tag--sale]="p.tag.kind === 'sale'"
                    >{{ p.tag.text }}</span
                  >
                }
              </div>
            </a>
            <div class="cat-product__info">
              <a class="cat-product__name-link" [routerLink]="['/producto', p.slug]">
                <h3 class="cat-product__name">{{ p.name }}</h3>
              </a>
              @if (p.oldPrice) {
                <div class="cat-product__prices">
                  <span class="cat-product__price">{{ p.price }}</span>
                  <span class="cat-product__old">{{ p.oldPrice }}</span>
                </div>
              } @else {
                <p class="cat-product__price">{{ p.price }}</p>
              }
              <button
                type="button"
                class="cat-product__cta"
                [class.cat-product__cta--added]="isAdded(p.id)"
                (click)="addToCart(p, $event)"
              >
                @if (isAdded(p.id)) {
                  Agregado
                } @else {
                  Agregar al carrito
                }
              </button>
            </div>
          </article>
        }
      </div>

      @if (totalPages() > 1) {
        <nav class="pagination" aria-label="Paginación">
          @for (n of pageNumbersList(); track n) {
            <button
              type="button"
              class="pagination__btn"
              [class.pagination__btn--active]="page() === n"
              (click)="goPage(n)"
              [attr.aria-current]="page() === n ? 'page' : null"
            >
              {{ n }}
            </button>
          }
          <button
            type="button"
            class="pagination__btn pagination__btn--icon"
            (click)="nextPage()"
            [disabled]="page() >= totalPages()"
            aria-label="Página siguiente"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <polyline points="9 6 15 12 9 18" />
            </svg>
          </button>
        </nav>
      }
    </div>
  </div>
</div>
